import { apiClient } from '../../gateways/api'
import type { Profile, ProfileChanges } from '../types/Profile'

export { updateProfile }

const updateProfile = async ({
  name,
  telefoon,
  rol,
}: ProfileChanges): Promise<Profile> => {
  const { data } = await apiClient({
    url: '/rest/account/profile',
    method: 'PATCH',
    data: { name, telefoon, rol },
  })

  return data
}
